class ProductAsync extends HTMLElement {
  connectedCallback () {
    this.fetchSection()
  }

  async fetchSection () {
    const response = await fetch(`/products/${this.handle}?sections=${this.sectionId}`).then(
      response => response.json(),
    )
    const parser = new DOMParser()
    const html = parser
      .parseFromString(response[this.sectionId], 'text/html')
      .querySelector(`#shopify-section-${this.sectionId}`)

    this.innerHTML = html.innerHTML
  }

  get handle () {
    return this.dataset.url.split('/products/')[1]
  }

  get sectionId () {
    if (this.dataset.productAsyncType === 'mini') {
      return 'async-product-card-mini'
    } else {
      return 'async-product-card-full'
    }
  }
}

if (!customElements.get('product-async')) {
  customElements.define('product-async', ProductAsync)
}
